import alert_mixin from '@/utils/mixins/alert_mixin';

export default {
  name: 'DocumentsWorkflow',
  mixins: [alert_mixin],
  data: () => ({
    search_query: '',
    active_tab: 'signing',
    configured_workflows: [
      {
        id: 1,
        name: 'Vendor NDA Execution',
        description: 'Automated non-disclosure routing for new technology partners and consulting firms.',
        status: 'active',
        entity: 'Supplier',
        last_modified_label: 'Last modified 2h ago',
      },
      {
        id: 2,
        name: 'Supplier Contract Review',
        description: 'Multi-tier approval chain for high-value logistics and procurement contracts.',
        status: 'draft',
        entity: 'Supplier',
        steps_remaining: 3,
      },
      {
        id: 3,
        name: 'Trust Deed Distribution',
        description: 'Automated quarterly trust distributions and notarized beneficiary confirmations.',
        status: 'active',
        entity: 'Trustee',
        auto_renewal_enabled: true,
      },
    ],
  }),
  computed: {
    filtered_workflows() {
      const query = (this.search_query || '').toLowerCase().trim();
      if (!query) return this.configured_workflows;

      return (Array.isArray(this.configured_workflows) ? this.configured_workflows : []).filter((workflow) => {
        const haystack = `${workflow?.name || ''} ${workflow?.description || ''} ${workflow?.entity || ''} ${workflow?.status || ''}`.toLowerCase();
        return haystack.includes(query);
      });
    },
    active_workflows_count() {
      return (Array.isArray(this.configured_workflows) ? this.configured_workflows : [])
        .filter((workflow) => String(workflow?.status || '').toLowerCase() === 'active').length;
    },
    pending_signs_count() {
      return (Array.isArray(this.configured_workflows) ? this.configured_workflows : [])
        .filter((workflow) => String(workflow?.status || '').toLowerCase() !== 'active').length;
    },
  },
  methods: {
    set_active_tab(tab_key) {
      this.active_tab = tab_key;
    },
    create_new_workflow() {
      this.show_info('Create workflow is coming next.');
    },
    export_workflows() {
      this.show_info('Export is coming next.');
    },
    share_workflows() {
      this.show_info('Share is coming next.');
    },
    edit_workflow(workflow) {
      this.show_info(`Edit workflow: ${workflow?.name || 'Workflow'}`);
    },
    assign_to_entity(workflow) {
      this.show_info(`Assign "${workflow?.name || 'Workflow'}" to an entity.`);
    },
  },
};
